<template>
    <ob-modal2 :show.sync="openModal" :type="1" :width="1200" >
        <div class="modal-header">
            <h4 class="log-trail">Activity Log</h4>
        </div>
        <div class="modal-body">
          <!-- Timeline View   -->
         <div v-if="ShowAuditTrial">
             <ob-spinner type="section"  v-if="isLoading" loading-text="Loading..."></ob-spinner>
                <div :id="id" v-else>
                   <div class="row" >
                        <h3 class="timeline-headding">Timeline View</h3>
                        <span class="generate-pdf" @click="printTimelineview()"><img style="margin:-2px 4px 0px 0px;width:25px;"  :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/pdf.svg`">  Generate PDF </span>
                    </div>
                    <div class="MT-Content-table" v-if="activityNames.length == 0">
                        <div class="MT-Content">
                            <h3 style="font-size: 18px; margin-top:140px">No Results found</h3>
                       </div>
                    </div>
                    <table style="width: 100%" v-if="activityNames.length">
                        <thead>
                           <tr>
                                <th class="date">DATE  &TIME</th>
                                <th class="name">NAME/USER ID</th>
                                <th class="actiontype">ACTION TYPE</th>
                                <th class="actions">Activity</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                           <tr class="i9-auditTrial__Content"  v-for="(item,index) in activityNames"  :key="item.id">
                              
                            <td><span :id="'tdspan'+(index*7)" class="filterSpan">{{item.timeanddate}}  {{ item.TimeZone}}</span></td>
                            <!-- <td><span :id="'tdspan'+(index*7)" class="filterSpan">{{item.timeanddate}}</span></td> -->
                            <td> <p class="filterSpan"><span :id="'tdspan'+(index*7 + 1)">{{item.name}} {{item.lastname}}  {{item.currentrole}}</span></p><p  style="font-size:10px" class="filterSpan"> <span :id="'tdspan'+(index*7 + 2)">{{item.email}}</span></p></td>
                            <td class="filterSpan"> <span :id="'tdspan'+(index*7 + 3)">{{item.status}}</span></td>
                            <td>                       
                                <p v-show="item.activity">{{item.activity}}</p>
                                <p class="filterSpan" v-if="item.fromdate != null && item.fromdate !=''">Timesheet Range :<b>  <span :id="'tdspan'+(index*7 + 4)">{{item.fromdate}} to {{item.todate}}</span></b></p>
                                <p class="filterSpan" v-if="item.totalhours != null && item.totalhours != ''">Total Hours:<b> <span :id="'tdspan'+(index*7 + 5)">{{item.totalhours}}</span></b></p>
                                <p class="filterSpan" v-if="item.totalhours != null && item.totalhours != ''">Project: <b><span :id="'tdspan'+(index*7 + 6)">{{item.project}}</span></b></p>
                                <p v-if="item.comments != null && item.comments != ''">Comments: <b><span :id="'tdspan'+(index*7 + 7)">{{item.comments}}</span></b></p>
                            </td>
                           </tr>
                        </tbody>
                    </table>
                 </div>
            </div>
         </div>
       <div class="modal-footer">
            <ob-button type="secondary" @click="openModal= false">Close</ob-button>
        </div>
</ob-modal2>
</template>
<script>
 export default {
        props: ['NewLogTrail','actiontype','performedActivity','selectionofProjects','activityperformedon','data'],
        data() {
            return {
                openModal: false,
                responsedata:'',
                isLoading:false,
                activityNames:[],
                PageIndex:0,
                PageSize:10,
                additional:'ActivityTrail' + __.random(10000, 99999),
                id: 'ActivityTrail' + __.random(10000, 99999)
                }
        },
        created() {
            this.$loading({ 'loadingText': 'Loading...' })
            this.openModal = this.NewLogTrail
            this.ShowAuditTrial = true
            //this.getSearchFilter()
            this.activityNames = this.data;
        },
        watch: {
            NewLogTrail(val) {
                this.openModal = val
            },
            openModal(val) {
                this.$emit('update:NewLogTrail', val)
                if (val == true)
                    this.ShowAuditTrial = true
                    //this.getSearchFilter()
                    this.activityNames = this.data;
                    }
                },
        methods: {
            OrganisationId(){
                     return this.loggedInUserObj.OrgId ? this.loggedInUserObj.OrgId : '';
                      },
            printTimelineview() {
                var w = window.open();
                var printOne = $('#'+this.id).html();
                w.document.write('<html><head><title>Activity Log</title><style>body { -webkit-print-color-adjust:exact;font-size: 13px; font-family: sans-serif;}.initiate_info{display:inline-block;padding:5px;}label{float:left;width:100%; }span{font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;font-size: 13px;font-weight: 700;color: #143361;margin: 0;line-height: 1.42857;display: block;}table{border: 1px solid #eee;border - radius: 4px;box - shadow: #eee 0px 0px 4px;}table thead tr {background-color: #eee;}table thead tr th {padding: 15px 10px;text-align:left;color: #333;font-size:12px;font-weight:600;}table tbody .i9-auditTrial__Content:nth-child(odd) {background-color: #f8f8f8;}table tbody .i9-auditTrial__Content:nth-child(even) {background-color: #fff;}  .generate-pdf{visibility: hidden;}table tbody td {word-wrap:break-word; padding: 15px 10px;;font-size:13px;color: #333;border-left:1px solid #fff;}</style></head><body onafterprint="window.close()"><h1>Activity Log</h1><hr />' + printOne + '<hr />' + '</body></html>');
                w.window.print();
                w.document.close();
              },
            getSearchFilter(){
                    this.activityNames=[]
                    var projectList=[]
                    projectList.push(this.selectionofProjects)
                    var actionList=[]
                    actionList.push(this.actiontype)
                    var actionPerfomedList=[]
                    actionPerfomedList.push(this.performedActivity)
                    var obj = {
                            'ActionsList':actionList,
                            'ActionsPerformedByUsersList':this.performedActivity != ''? this.performedActivity:[""],
                            'ActionsPerformedDateRange':this.activityperformedon,
                            'TimesheetIdList':[""],
                            'ProjectIdList':projectList,
                            'EmployeeId':"",
                            'FromDate':"",
                            'ToDate':""
                       }
                       this.isLoading=true
                      ajax.put(`/TimeSheets/Activity?Id=${this.loggedInUserObj.orgId}&pageno=${this.PageIndex}&pagesize=${this.PageSize}`,obj,(res)=>{
                          if(res.data.State==true){
                          this.$loading({ 'loadingText': 'Loading...' })
                          if(res.data.data.length!=0){
                              var responsedata=res.data.data;
                              responsedata.forEach((e)=>{
                               this.activityNames.push({"timeanddate":moment(e.activityLogDateTime.Date).utc().format('MM/DD/YYYY hh:mm:ss a'),"email":e.actionDoneBy.Email,"name":e.actionDoneBy.FirstName,
                               "lastname":e.actionDoneBy.LastName,"currentrole":e.actionDoneBy.CurrentRole,"fromdate":e.metaInformation.FromDate,
                               "todate":e.metaInformation.ToDate,"comments":e.metaInformation.Comment,
                               "status":e.metaInformation.TimesheetActionType,"totalhours":e.metaInformation.TotalHours,
                               "project":e.metaInformation.Project})
                           })
                              this.$loading({}).close();
                             }
                           }
                           this.isLoading=false
                       })
            },
            openAudit() {
             this.ShowAuditTrial = true
            },
            viewSummaryPopUp() {
             this.ShowAuditTrial = false
            },
        }
        }

</script>

<style lang="scss" scoped>
     .log-trail{
         font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
          font-size: 17px;
          font-weight: 700;
          color: #143361;
          margin-left:10px;
          line-height: 1.42857;
          display: block;
          padding-right:851px;
     }
     .timeline-headding{
          font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
          font-weight: 700;
          color: #143361;
          margin: 0;
          margin-bottom:10px;
          padding-left:14px;
    }
    .generate-pdf{
            float: right;
            font-size: 13px;
            color: #143361;
            font-weight: 600;
            padding-top:3px;
            cursor:pointer;
            padding-right:15px;
            margin:-32px 30px 20px 0px;
    }
    .additionasection-content{
       font-style:italic;
       color:grey;
       font-size:11px;
    }
    .created{
        color:#4a90e2;
        font-size: 13px;
        margin-bottom:5px;
        margin-right:2px;
        font-weight:600;
    }
    .additional-Info{
      color:#4a90e2;
      font-size: 14px;
      margin:12px 2px 12px 0px;
      font-weight:600;
    }
    .activityview-email{
        color:grey;
        font-size:11px;
    }
    .date{
      width: 20%;
     }
     .name{
          width: 20%;
      }
    //  .ipaddress{
    //     width: 15%;
    //  }
     .actiontype{
        width: 20%;
     }
     .actions{
         width:30% !important
     }
    .initiatedinfo{
          font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
          font-size: 13px;
          font-weight: 700;
          color: #143361;
          margin: 0;
          line-height: 1.42857;
          display: block;
        }
    
     .pdf-icon{
         margin:-2px 4px 0px 0px;
         width:25px;
     }
     label{
         font-size: 12px;
         color:rgb(51, 51, 51);
        }
     .modal-header{
        h4{
              display:inline-block;
        }
        a{
            float: right;
            font-size: 12px;
            font-style: italic;
            text-decoration: underline;
            color: #4a90e2;
            font-weight: 600;
            letter-spacing: 0.3px;
            padding-top:3px;
        }
    }
    .modal-body {
        padding: 20px 25px 35px;
        table{
            border: 1px solid #eee;
            border-radius: 4px;
            box-shadow: #eee 0px 0px 4px;
            thead{
                    tr{
                        background:#eee;
                        th{
                            /*width:50%;*/
                            padding:15px 30px;
                            //text-align: center;
                            color: #333;
                            font-size: 12px;
                            font-weight: 600;
                            white-space: initial;
                        }
                    }
            }
            tbody{
                    tr{
                        td{
                            white-space: initial;
                            word-wrap: break-word;
                        }
                    }
                    .email{
                        width: 21%;
                    }
                    .userId{
                        width: 9%;

                    }
                    .name{
                        width: 10%;

                    }
                    .location{
                        width: 10%;

                    }
                    .ip{
                        width: 10%;

                    }
                    .action{
                        width: 50% !important;
                    }
                    .i9-auditTrial__Heading{
                        //background: #f8f8f8;
                        text-decoration: underline;
                        color: #333;
                        padding-bottom: 5px;
                        font-weight: 600;
                    }
                    .i9-auditTrial__Content{
                        &:nth-child(odd){
                                background: #f8f8f8;
                        }
                        &:nth-child(even){
                                background: #fff;
                        }
                      }
                    td{
                         padding:15px 30px;
                         color:#333;
                         word-wrap: break-word;
                    }
                    .i9-summary__subContent{
                        font-weight:600;
                    }
                }
            }
    }

</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/EmployeePopup.vue